// Modules
import React from "react";
// @ts-ignore
import { LocalizationContext } from 'react-localize';

// Components
import MvModal from "Generic/MvModal";
import MvLoader from "Generic/MvLoader/MvLoader"
import { MvInputGrp, InputType } from 'Generic/MvInputGrp';
import { MvCharCnt } from 'Generic/MvCharCnt'; 

// Styles
import "./styles.sass"

// Interfaces
import { Preferences } from "Interfaces/AYPResultInterface";
import { SelectedPreferences } from "../Review/Review";

interface Props {
    show: boolean;
    toggle: (show: boolean) => void;
    preferenceOptions: Preferences;
    onUpdate: (prefs: SelectedPreferences) => void;
    optionsLoading: boolean;
    selectedPreferences: SelectedPreferences;
};

type PreferencesModalState = {
    selectedPreferences: SelectedPreferences;
}

class PreferencesModal extends React.Component<Props, PreferencesModalState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            selectedPreferences: props.selectedPreferences,
        };
    }

    componentWillReceiveProps(nextProps: Props) {
        if (!this.props.show && nextProps.show) {
            this.setState({ selectedPreferences: nextProps.selectedPreferences });
        }
    }

    onRoomPreferenceUpdate = (code: string, selected: string|string[], isMulti: boolean) => {
        this.setState({
            selectedPreferences: {
                ...this.state.selectedPreferences,
                roomRequests: {
                    ...this.state.selectedPreferences.roomRequests,
                    [code]: selected,
                },
            },
        });
    }

    onAdditionalRequestUpdate = (additionalRequests: string) => {
        this.setState({
            selectedPreferences: {
                ...this.state.selectedPreferences,
                additionalRequests,
            },
        });
    }

    render() {
        const { localize } = this.context;
        const {
            show,
            toggle,
            preferenceOptions,
            selectedPreferences,
        } = this.props;

        return (
            <MvModal
                openModal={show}
                toggleModal={() => {
                    // close modal
                    toggle(false);

                    // reset selections to selections from props
                    this.setState({ selectedPreferences });
                }}
                scrollY={true}
            >
                <div className='preferences-modal'>
                    <MvLoader show={this.props.optionsLoading}>
                        <div className='header'>
                            <h3>{localize("static.content.sr-preference-modal-header")}</h3>
                            <p>{localize("static.content.sr-preference-modal-sub-heading")}</p>
                        </div>

                        <h3>{localize("static.content.sr-preference-modal-room-header")}</h3>
                        <div className='preference-groups'>
                            {preferenceOptions.map(pref => {
                                return (
                                    <MvInputGrp
                                        name={pref.code}
                                        value={this.state.selectedPreferences.roomRequests[pref.code] || []}
                                        id={pref.code}
                                        heading={pref.name}
                                        inputType={pref.multiselect ? InputType.checkbox : InputType.radio}
                                        onChange={(selected: string|string[]) => this.onRoomPreferenceUpdate(pref.code, selected, pref.multiselect)}
                                        options={pref.options.map(opt => ({ label: opt.name, value: opt.code }))}
                                    />
                                );
                            })}
                        </div>
                        <MvCharCnt
                            maxChar={45}
                            value={this.state.selectedPreferences.additionalRequests}
                            onChange={this.onAdditionalRequestUpdate}
                            header={'Additional Requests'}
                            helperText={'Any special requests or needs?'}
                        />
                        <div className='submit-container'>
                            <button
                                className="mv-button primary"
                                onClick={() => {
                                    // close modal
                                    toggle(false);

                                    // update preferences
                                    this.props.onUpdate(this.state.selectedPreferences);
                                }}
                            >
                                {'Update'}
                            </button>
                        </div>
                    </MvLoader>
                </div>
            </MvModal>
        );
    }
};

PreferencesModal.contextType = LocalizationContext;
export {
    PreferencesModal,
};
